import React, { FC } from 'react';
import { Box, RadioGroup, Typography } from '@mui/material';
import { Option } from 'types/Menu';
import { OptionRadioButton } from 'components/generic';
import { useTranslation } from 'react-i18next';

interface OptionsProps {
  options: Option[];
}

const Options: FC<OptionsProps> = ({ options }) => {
  const { t } = useTranslation();
  return (
    <Box>
      <Typography
        sx={{
          fontSize: { xs: '16px', sm: '20px' },
          lineHeight: { xs: '19px', sm: '23px' },
          marginBottom: '10px',
        }}
      >
        {t('options')}
      </Typography>

      <Box sx={{ marginBottom: '14px' }}>
        <RadioGroup
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
          aria-label="Options"
          defaultValue={options[0].id}
          name="options"
        >
          {options.map((option) => (
            <OptionRadioButton
              key={option.id}
              label={option.description}
              group="option"
              value={option.id}
            />
          ))}
        </RadioGroup>
      </Box>
    </Box>
  );
};

export default Options;
